import { useGetPendingShippingsWithReturnsIntakeListQuery } from '../../services/returnsIntake.endpoints';
import { extractDate, extractTime } from '@/utils';
import { ReturnsIntakeFilters } from '../../models';

interface UsePendingShippingsProps {
  filters: ReturnsIntakeFilters;
  page: number;
  pageSize: number;
}

export const usePendingShippings = ({
  filters,
  page,
  pageSize,
}: UsePendingShippingsProps) => {
  const { data, isLoading } = useGetPendingShippingsWithReturnsIntakeListQuery({
    filters,
    paginated: { page, pageSize },
  });

  const formatDate = (dateString: string | null | undefined) => {
    if (!dateString) return '-';
    const date: string = extractDate(dateString);
    const time: string = extractTime(dateString);
    if (date === 'N/A' || date === 'Fecha inválida') return '-';
    return `${date} ${time}`;
  };

  return {
    shippings: data?.items || [],
    totalItems: data?.count || 0,
    totalPages: Math.ceil((data?.count || 0) / pageSize),
    isLoading,
    formatDate,
  };
};
